import React from 'react';
import classNames from 'classnames';

import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import { createResourceLocatorString } from '../../util/routes';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import { H2, NamedLink } from '..';

import css from './SectionFeaturedProducts.module.css';

import { createSlug } from '../../util/urlHelpers';
import NoImageIcon from '../ResponsiveImage/NoImageIcon';
import { useNativeLang } from '../../hooks/useNativeLang';
import { ReactComponent as ArrowRightSVG } from '../../assets/svg/arrow-right.svg';

const SectionFeaturedProducts = props => {
  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();
  const { userNativeLang } = useNativeLang();
  const { intl, featuredProducts } = props;

  const noImage = (
    <div className={css.noImageWrapper}>
      <NoImageIcon className={css.noImageIcon} />
      <div className={css.noImageText}>
        <FormattedMessage id="ResponsiveImage.noImage" />
      </div>
    </div>
  );

  return (
    <article className={css.root}>
      <H2 as="h2" className={css.articleHeader}>
        <FormattedMessage id="LandingPage.featuredProducts" />
        <NamedLink
          name="SearchPage"
          className={css.viewAll}
          to={{ search: 'meta_featuredProduct=true' }}
        >
          <FormattedMessage id="LandingPage.viewAll" />
          <ArrowRightSVG />
        </NamedLink>
      </H2>

      <section className={classNames(css.gridContainer)}>
        {/* {Array.from({ length: 3 }, (_, index) => index + 1).map(e => ( */}
        {featuredProducts.map(prod => {
          const {
            id: { uuid },
            attributes: {
              title,
              publicData: { brandPhoto: [firstBrandPhoto] = [] } = {},
              metadata: { trTitle, trLang } = {},
            },
            images: [firstImage] = [],
          } = prod;
          const image = firstImage?.attributes?.variants?.default?.url ?? firstBrandPhoto?.location;
          const prodName = (userNativeLang === trLang && trTitle) || title;
          return (
            <button
              key={uuid}
              className={css.gridContent}
              onClick={() => {
                history.push(
                  createResourceLocatorString(
                    'ListingPage',
                    routeConfiguration,
                    { id: uuid, slug: createSlug(title) },
                    {}
                  )
                );
              }}
            >
              <div className={css.image}>
                {image ? <img src={image} alt={prod.name} /> : noImage}
              </div>

              <div className={css.content}>
                <p>{prodName}</p>
              </div>
            </button>
          );
        })}
      </section>
    </article>
  );
};

export default compose(injectIntl)(SectionFeaturedProducts);
